module.exports = __webpack_public_path__ + "img/fy.43e86367.png";